// extracted by mini-css-extract-plugin
export default {"customRow":"Login_customRow__TUrDL"};